import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

export default function SeoMeta() {
  const { t, i18n } = useTranslation();

  const meta = {
    en: {
      description:
        "A donation service that allows you to make small contributions—like the cost of a cup of coffee—to digital creators who make a positive impact on the world.",
      keywords:
        "caffee, hanzan, donation, make, button, creators, service, supporters",
    },
    ko: {
      description: "세상에 선한 영향력을 끼치는 크리에이터에게...",
      keywords:
        "세상에 선한 영향력을 끼치는 디지털 크리에이터들에게 커피 값 만큼 소액 후원을 할 수 있는 도네이션 서비스",
    },
  };

  const current = meta[i18n.language] || meta.en;

  return (
    <Helmet>
      <html lang={i18n.language} />
      <meta name="description" content={current.description} />
      <meta name="keywords" content={current.keywords} />
      <title>{i18n.language === "ko" ? "후원한잔 | Hanzan" : "Hanzan"}</title>
    </Helmet>
  );
}
